export default "__VITE_ASSET___SfakKMT__"